module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register_msg_yz register_box"
  }, [_c('h4', {
    staticClass: "color_5babf4 login_title"
  }, [_vm._v("注册成功！")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "account_password_box color_f clearfix"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t登录账户："), _c('span', [_vm._v(_vm._s(_vm.mob))])]), _vm._v(" "), _c('h5', {
    staticClass: "text-center pwdshow"
  }, [_vm._v("\n\t\t\t登录密码："), _c('span', [_vm._v(_vm._s(_vm.yhmm))])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn_issue",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.loginOption
    }
  }, [_vm._v("登录选择")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip_sub_text"
  }, [_c('small', [_vm._v("请牢记您的账户和密码,忘记密码可用手机找回密码！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0cdb3987"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/register_success.vue
// module id = 1236
// module chunks = 1